import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import config from '../../config'
import Loader from 'react-loader'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import convert from '../../helpers/convert'
import { asyncConnect } from 'redux-async-connect'
import container from '../../helpers/container'
import analytics from '../../helpers/analytics'
import {Row, Col} from 'react-flexbox-grid'
import {
  Grade,
  Link,
  LinkIcon,
  FundMenu,
  FundName,
  FundShareTakeAction,
  InlineSignup,
  ContainerDivs,
  IyvScorecard,
  // AssetManagerLetter
} from '../../components'
import * as searchActions from 'redux/modules/search'
import Styles from './FundInvestmentProfile.css'

@connect(
  state => ({
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error
  }),
  searchActions)

@asyncConnect([{
  deferred: true, // need otherwise cient navigate is blocked until the page is loaded
  promise: ({params, store: {dispatch, getState}}) => {
    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId))
  }
}])

@CSSModules(Styles, {allowMultiple:true})
export default class FundInvestmentProfile extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object
  }
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
    analytics.event(analytics.eventLoadFund(this.props.params.fundId, this.props.params.investmentVehicleId))
    this._mounted = true
    // const sector = this.props.sector ? this.props.sector : {}
    // this.props.sectorChange(sector)
  }

  componentWillReceiveProps(nextProps) {
  }

  componentWillUnmount() {
    this._mounted = false
  }

  handleScroll = () => {
    if ( !this._mounted ) { return }
    if ( !this.props.result ) { return }
    // const shareClass = this.props.result.shareClass
    // const scrollTop = event.srcElement.body.scrollTop
  }

  // need this solution since asyncConnect and anchor links does not play nice
  scrollTo = (id) =>{
    return () =>{
      const ele = document.getElementById(id)
      window.scrollTo(ele.offsetLeft,ele.offsetTop)
    }
  }

  renderStats = (shareClass) => {
    function renderCol(type, entries, hasLine) {
      return (
        <Col xs={6} styleName={'col-'+type+'-wrapper'}>

          {
            entries.map((entry,idx) => {
              return (
                <div
                  key={idx}
                  styleName='col-label-value'>

                  <div styleName={'col-'+type}>
                    <div styleName='stats-label'>{entry.name}</div>

                    {
                      (entry.link) ? (
                        <Link
                          to={entry.link}
                          title={entry.value}
                          xstrong={true}
                        >
                          <div styleName='stats-value-link'>{entry.value}<LinkIcon/></div>
                        </Link>
                      ) : <div styleName='stats-value'>{entry.value}</div>
                    }

                  </div>

                  {
                    (hasLine && (idx !== entries.length-1)) ? (
                      <div styleName='col-line'/>
                    ) : null
                  }

                </div>
              )
            })
          }

        </Col>
      )
    }

    const dest = encodeURIComponent(shareClass.fund_family_name)

    return (
      <div styleName='stats'>
        <div styleName='stats-inner'>

          <Row styleName='stats-header'>
            <Col xs={12} sm={6} md={6} lg={6}>
              <div styleName='stats-title'>
                Fund investment profile
              </div>
            </Col>
            <Col xs={12} sm={6} md={6} lg={6}>
              { /* <div styleName='stats-score-label-score'>
                <div styleName='stats-score-wrapper'>
                  <div styleName='profile-grade-title'>
                    Fossil fuel grade:
                  </div>
                  &nbsp;&nbsp;

                  <Grade
                    grade={shareClass.grade_fossil}
                    blocksmall
                  />

                </div>
              </div> */ }
            </Col>
          </Row>

          <div styleName='line'/>
          <Row>
            { renderCol('left', [{name: 'Shareclass ticker', value:shareClass.ticker}], false) }
            { renderCol('right', [{name: 'Data as of', value:moment(shareClass.date.slice(0,10)).format('D MMM YYYY')}], false) }
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Shareclass name', value:shareClass.name}], false) }
            { renderCol('right', [{name: '% of fund assets screened', value:format.perc(shareClass.percent_rated) }], false) }
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Shareclass type', value:format.legalType(shareClass.legal_type)}], false) }
            { renderCol('right', [{name: 'Fund net assets', value:format.money(shareClass.fund_net_assets, true, shareClass.currency)}], false) }
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Fund family', link:config.routes.families+'?q='+dest, value:shareClass.fund_family_name}], false) }
            { renderCol('right', [{name: 'Fund group', value:shareClass.category_group }], false) }
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Domicile country', value:format.market(shareClass.market)}], false) }
            { renderCol('right', [{name: 'Portfolio currency', value:format.currencyCode(shareClass.currency)}], false) }
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Sustainable investment', value:format.boolean(shareClass.ussif || '0')}], false) }
            { renderCol('right', [{name: '', value: ''}], false) }
          </Row>

          { /* FOSSIL FUEL STATS */ }
          <div styleName='stats-totals'>
            <div styleName='stats-totals-header'>
              Fossil fuels
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Fossil fuel grade</div>
              <div styleName='stats-total-value'>
                <div styleName='badge-grade-wrap'>
                  <Grade grade={shareClass.grade_fossil} blocksmall/>
                </div>
              </div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total fossil fuel stock holdings</div>
              <div styleName='stats-total-value'>{ format.number(shareClass.c2f5coogutcount) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total % invested in fossil fuel stocks</div>
              <div styleName='stats-total-value'>{ format.perc(shareClass.c2f5coogutweight) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total assets invested in fossil fuel stocks</div>
              <div styleName='stats-total-value'>
                { format.money(shareClass.c2f5coogutasset, true, shareClass.currency, false) }
              </div>
            </div>
            { /* <div styleName='stats-total'>
              <div styleName='stats-total-name'>Fossil fuel badges (legacy grade)</div>
              <div styleName='stats-total-value'>
                <div styleName='badge-grade-wrap'>
                  <Badges
                    fund={shareClass}
                    small={true}
                  />
                  <ReactTooltip id='badges-tooltip'/>
                </div>
              </div>
            </div> */ }
          </div>

          { /* FOSSIL FINANCE STATS */ }
          <div styleName='stats-totals'>
            <div styleName='stats-totals-header'>
              Fossil fuel finance
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Fossil fuel finance grade</div>
              <div styleName='stats-total-value'>
                <div styleName='badge-grade-wrap'>
                  <Grade grade={shareClass.grade_fossil_bank} blocksmall/>
                </div>
              </div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Fossil fuel finance score</div>
              <div styleName='stats-total-value'>{ shareClass._fossil_bank_score }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total fossil fuel finance stock holdings</div>
              <div styleName='stats-total-value'>{ format.number(shareClass.fossil_bank_count) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total % invested in fossil fuel finance stocks</div>
              <div styleName='stats-total-value'>{ format.perc(shareClass.fossil_bank_weight) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total assets invested in fossil fuel finance stocks</div>
              <div styleName='stats-total-value'>
                { format.money(shareClass.fossil_bank_asset, true, shareClass.currency, false) }
              </div>
            </div>
          </div>

          { /* FOSSIL INSURANCE STATS */ }
          <div styleName='stats-totals'>
            <div styleName='stats-totals-header'>
              Fossil fuel insurance
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Fossil fuel insurance grade</div>
              <div styleName='stats-total-value'>
                <div styleName='badge-grade-wrap'>
                  <Grade grade={shareClass.grade_fossil_bank} blocksmall/>
                </div>
              </div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Fossil fuel insurance score</div>
              <div styleName='stats-total-value'>{ shareClass._fossil_insure_score }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total fossil fuel insurance stock holdings</div>
              <div styleName='stats-total-value'>{ format.number(shareClass.fossil_insure_count) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total % invested in fossil fuel insurance stocks</div>
              <div styleName='stats-total-value'>{ format.perc(shareClass.fossil_insure_weight) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total assets invested in fossil fuel insurance stocks</div>
              <div styleName='stats-total-value'>
                { format.money(shareClass.fossil_insure_asset, true, shareClass.currency, false) }
              </div>
            </div>
          </div>

          { /* CLEAN200 STATS */ }
          <div styleName='stats-totals'>
            <div styleName='stats-totals-header'>
              Clean200
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total Clean200 stock holdings</div>
              <div styleName='stats-total-value'>{ format.number(shareClass.cl_count) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total % invested in Clean200 stocks</div>
              <div styleName='stats-total-value'>{ format.perc(shareClass.cl_weight) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total assets invested in Clean200 stocks</div>
              <div styleName='stats-total-value'>
                { format.money(shareClass.cl_asset, true, shareClass.currency, false) }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    if( !this.props.result ){
      return (
        <div styleName='main'>
          <Loader options={{scale: 0.70, top:'2.0rem'}} loaded={ false }/>
        </div>
      )
    } else if ( this.props.result && (!this.props.result.fund || !this.props.result.shareClass) ) {
      this.context.router.push(config.routes.notFound)
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={ false }
          />
        </div>
      )
    }

    const { fund, shareClass } = this.props.result
    const title = shareClass.fund_legal_name + ' | Investment Profile'
    const ticker = shareClass.ticker ? shareClass.ticker : 'N'
    const name = format.sanitize(shareClass.fund_legal_name)
    const urlStart = config.routes.fund+'/'+name+'/'+ticker
    const urlEnd = shareClass.fund_id+'/'+shareClass.investment_vehicle_id
    const url = config.domain+urlStart+'/investment-profile/'+urlEnd

    const _ticker = shareClass.ticker || null
    let fundName = `${fund.fund_legal_name}`
    fundName = _ticker ? `${fundName} ${_ticker}` : fundName
    const ffAsset = convert.int(fund.c2f5coogutasset)
    const ffWeight = convert.float(fund.c2f5coogutweight)
    const _ffAsset = format.money(ffAsset, true, 'USD', false)
    const _ffWeight = format.perc(ffWeight)
    const description = `${fundName} has ${_ffAsset} invested in fossil fuels, ${_ffWeight} of the fund`

    const scoreFormatterFn = (s) => {
      let _s = format.number(s, false, false, 1)
      if (parseFloat(_s) === 0 && parseFloat(s)>0) {
        _s = '<0.1'
      } else if (_s.slice(-1)==='0' && parseFloat(s)<=0) {
        _s = format.number(s, false, false, 0)
      }
      return _s
    }

    shareClass._fossil_bank_score = scoreFormatterFn(shareClass.fossil_bank_score)
    shareClass._fossil_insure_score = scoreFormatterFn(shareClass.fossil_insure_score)

    //
    return (
      <div>
        {container.helmet(title, description, url)}

        <br/>
        <FundMenu
          active={'More'}
          fundId={shareClass.fund_id}
          investmentVehicleId={shareClass.investment_vehicle_id}
          name={shareClass.fund_legal_name}
          ticker={shareClass.ticker}
        />

        <FundName
          shareClass={shareClass}
          pathname={this.props.location.pathname}
        />

        { /* temporary asset manager letter for Vanguard */ }
        { /* <AssetManagerLetter fundFamilyName={fund.fund_family_name}/> */ }

        <div styleName='main'>

          { this.renderStats(shareClass) }

        </div>

        <ContainerDivs>
          <br/>
          <br/>
          <br/>
          <InlineSignup />
        </ContainerDivs>

        { /* <FundNext
          prev={'clean200-investments'}
          prevLabel={'Clean200'}
          next={''}
          nextLabel={''}
          ticker={shareClass.ticker}
          name={shareClass.fund_legal_name}
          fundId={shareClass.fund_id}
          investmentVehicleId={shareClass.investment_vehicle_id}
        /> */ }

        { /*
        <IyvScorecard
          fund={fund}
          shareClass={shareClass}
        />
        */ }

        { /*
        <FundShareTakeAction
          shareClass={shareClass}
          url={url}
          type={'investment-profile'}
        />
        */ }

      </div>
    )
  }
}
